/* eslint-disable no-unsafe-optional-chaining */
import useCommon from '@utils/hooks/common';
import MultiUnitStatistic from '@components/game-room/MultiUnitStatistic';
import React from 'react';
import styles from './styles';

interface PingTimerProps {
  pot?: number;
}

const PotArea = React.memo((props: PingTimerProps) => {
  const {classes, t} = useCommon({
    withStyles: styles,
    withTranslation: ['table_area', 'best_combination', 'common'],
  });

  return (
    <article className={classes.potArea}>
      <div className={classes.potInfoContainer}>
        <div className={classes.potLabel}>{t('pot')}</div>
        <MultiUnitStatistic
          value={props.pot || 0}
          valueStyle={{
            color: '#DDB855',
            lineHeight: '105%',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        />
      </div>
    </article>
  );
});

PotArea.displayName = 'PotArea';

export default PotArea;
